import { render, staticRenderFns } from "./CharpterTree.vue?vue&type=template&id=a6b0af34&scoped=true&"
import script from "./CharpterTree.vue?vue&type=script&lang=js&"
export * from "./CharpterTree.vue?vue&type=script&lang=js&"
import style0 from "./CharpterTree.vue?vue&type=style&index=0&id=a6b0af34&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6b0af34",
  null
  
)

export default component.exports